import {apiHost} from '@/config/config'
import axios from 'axios';

const resourceHost = apiHost

const enhanceAccessToken = () => {
    const {accessToken} = localStorage
    if (!accessToken) return axios.defaults.headers.common['x-access-token'] = `${accessToken}`;
}
const enhanceRefreshToken = () => {
    const {refreshToken} = localStorage
    if (!refreshToken) return axios.defaults.headers.common['x-refresh-token'] = `${refreshToken}`;
}
enhanceAccessToken()
enhanceRefreshToken()

const state ={
    accessToken: null,
    refreshToken: null
}
const mutations = {
    SIGNIN (state, {accessToken, refreshToken}){
        state.accessToken = accessToken
        state.refreshToken = refreshToken
        localStorage.accessToken = accessToken
        localStorage.refreshToken = refreshToken
    },
    SIGNOUT (state) {
    state.accessToken = null
    state.refreshToken = null
    delete localStorage.accessToken
    delete localStorage.refreshToken
    },
    REFRESH (state,{accessToken}){
        state.accessToken = accessToken
        localStorage.accessToken = accessToken
    }
};

const getters = {
    isAuthenticated (state){
        state.accessToken = state.accessToken || localStorage.accessToken
        state.refreshToken = state.refreshToken || localStorage.refreshToken
        return state.accessToken
    },
    getAccessToken (state){
        return state.accessToken
    },
    getRefreshToken (state){
        return state.refreshToken
    }
};

const actions = {
    SIGNIN ({commit}, {userId, password}) {
        return axios.post(`${resourceHost}/users/login`, {userId, password})
        .then(res => {
            commit('SIGNIN', res.data)
            axios.defaults.headers.common['x-access-token'] = `${res.data.accessToken}`;
            axios.defaults.headers.common['x-refresh-token'] = `${res.data.refreshToken}`;
        })
    },
    SIGNOUT ({commit}){
        axios.defaults.headers.common['x-access-token'] = undefined
        axios.defaults.headers.common['x-refresh-token'] = undefined
        commit('SIGNOUT')
    },
    REFRESH ({commit}){
            return axios.get(`${resourceHost}/reception`)
            .then(res => {
            })
            .catch(err => {
                //token refresh
                if(err.response.status === 401){
                    return axios.get(`${resourceHost}/users/reissuance`)
                    .then(res => {
                        
                        axios.defaults.headers.common['x-access-token'] = `${res.data.accessToken}`;
                        commit('REFRESH',res.data)
                    });
                }
            })
    }
};

export default{
    enhanceAccessToken,
    mutations,
    getters,
    state,
    actions,
}


// WEBPACK FOOTER //
// ./src/store/modules/auth.js